import { ConfirmationDrawer } from 'library/drawer';
import { ReactNode, forwardRef } from 'react';
import { DrawerProps } from './Drawer';

interface DeleteConfirmationDrawerProps extends Omit<DrawerProps, 'title' | 'children'> {
    title?: ReactNode;
    message: ReactNode;
    onConfirm?: () => void;
    isConfirming?: boolean;
    confirmText?: string;
    confirmLoadingText?: string;
    cancelText?: string;
}

const DeleteConfirmationDrawer = forwardRef<HTMLDivElement, DeleteConfirmationDrawerProps>((props, ref) => {
    const {
        title = 'Confirm delete',
        isConfirming = false,
        confirmText = 'Delete',
        confirmLoadingText = 'Deleting',
        cancelText = 'Cancel',
        ...rest
    } = props;

    return (
        <ConfirmationDrawer
            ref={ref}
            title={title}
            confirmText={confirmText}
            confirmLoadingText={confirmLoadingText}
            isConfirming={isConfirming}
            cancelText={cancelText}
            {...rest}
        />
    );
});

export default DeleteConfirmationDrawer;
